<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option v-if="firstOption" value="">{{ firstOption }}</option>
    <option
      v-for="reason in selects"
      :key="reason.id"
      :value="reason.reason"
      :selected="reason.reason === selected"
      >{{ reason.reason }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectStatusReasons',
  data() {
    return {
      selects: [],
      firstOption: this.first ? this.first : null,
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    status: {
      type: [Number, String],
    },
  },
  watch: {
    status(newVal) {
      this.getData(newVal);
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/customer/status-reason/${this.status}/all`).then(
        (res) => (this.selects = res.data)
      );
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData(this.status);
  },
};
</script>
